// Strings locales del módulo M5 · Mi perfil (docs/05 §/profile). Las claves de nav
// y de shell viven en el diccionario global (i18n/es.ts); aquí solo lo propio de
// la pantalla. Sin literales sueltos en JSX.
export const profileI18n = {
  title: "Mi perfil",
  description: "Edita tus datos y tu contraseña.",
  loadError: "No se pudo cargar tu perfil.",

  // Sección de datos del perfil
  details: {
    heading: "Datos del perfil",
    identifierLabel: "Identificador",
    identifierHint: "Tu usuario de inicio de sesión no es editable.",
    domainLabel: "Dominio",
    nameLabel: "Nombre",
    namePlaceholder: "Tu nombre completo",
    emailLabel: "Email de contacto",
    emailPlaceholder: "nombre@empresa.com",
    emailHint: "Se usa para recuperación de contraseña y avisos.",
    save: "Guardar cambios",
    saved: "Perfil actualizado.",
  },

  // Sección de cambio de contraseña
  password: {
    heading: "Cambiar contraseña",
    description: "Al cambiarla se cerrarán tus demás sesiones.",
    currentLabel: "Contraseña actual",
    newLabel: "Nueva contraseña",
    confirmLabel: "Confirmar nueva contraseña",
    submit: "Cambiar contraseña",
    changed: "Contraseña cambiada. Vuelve a iniciar sesión.",
  },

  validation: {
    nameTooLong: "El nombre no puede superar los 200 caracteres.",
    emailFormat: "Escribe un email válido.",
    currentRequired: "Escribe tu contraseña actual.",
    newRequired: "Escribe la nueva contraseña.",
    confirmRequired: "Repite la nueva contraseña.",
    confirmMismatch: "Las contraseñas no coinciden.",
  },
} as const
